"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Accordion = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/Accordion/index"))));
var BlogSideBar = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/BlogSideBar/index"))));
var CalculatorCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/CalculatorCard/index"))));
var CallOutCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/CallOutCard/index"))));
var CardLinkList = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/CardLinkList/index"))));
var CardList = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/CardList/index"))));
var ContactCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/ContactCard/index"))));
var FeaturedStats = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/FeaturedStats/index"))));
var HorizontalCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/HorizontalCard/index"))));
var HorizontalLineCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/HorizontalLineCard/index"))));
var HorizontalTimeline = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/HorizontalTimeline/index"))));
var LoginCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/LoginCard/index"))));
var MediaCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/MediaCard/index"))));
var MediaColumn = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/MediaColumn/index"))));
var MediaHorizontalCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/MediaHorizontalCard/index"))));
var StyledHeading = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/StyledHeading/index"))));
var TitleTaglineDisplay = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/TitleTaglineDisplay/index"))));
var TabNavHorizontal = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/TabNavHorizontal/index"))));
var TabNavVertical = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/TabNavVertical/index"))));
var VerticalCard = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/VerticalCard/index"))));
var VerticalTimeline = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/VerticalTimeline/index"))));
var VideoPlayer = (0, _component.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../renderings/VideoPlayer/index"))));
var LoadComponent = props => {
  var propRendering = {
    fields: props.rendering.fields,
    dataSource: props.rendering.id
  };
  switch (props.name) {
    case 'Accordion':
      return /*#__PURE__*/_react.default.createElement(Accordion, {
        rendering: propRendering,
        params: props.params
      });
    case 'BlogSideBar':
      return /*#__PURE__*/_react.default.createElement(BlogSideBar, {
        rendering: propRendering,
        params: props.params
      });
    case 'CalculatorCard':
      return /*#__PURE__*/_react.default.createElement(CalculatorCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'CallOutCard':
      return /*#__PURE__*/_react.default.createElement(CallOutCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'CardLinkList':
      return /*#__PURE__*/_react.default.createElement(CardLinkList, {
        rendering: propRendering,
        params: props.params
      });
    case 'CardList':
      return /*#__PURE__*/_react.default.createElement(CardList, {
        rendering: propRendering,
        params: props.params
      });
    case 'ContactCard':
      return /*#__PURE__*/_react.default.createElement(ContactCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'FeaturedStats':
      return /*#__PURE__*/_react.default.createElement(FeaturedStats, {
        rendering: propRendering,
        params: props.params
      });
    case 'HorizontalCard':
      return /*#__PURE__*/_react.default.createElement(HorizontalCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'HorizontalLineCard':
      return /*#__PURE__*/_react.default.createElement(HorizontalLineCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'HorizontalTimeline':
      return /*#__PURE__*/_react.default.createElement(HorizontalTimeline, {
        rendering: propRendering,
        params: props.params
      });
    case 'LoginCard':
      return /*#__PURE__*/_react.default.createElement(LoginCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'MediaCard':
      return /*#__PURE__*/_react.default.createElement(MediaCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'MediaColumn':
      return /*#__PURE__*/_react.default.createElement(MediaColumn, {
        rendering: props.rendering,
        params: props.params
      });
    case 'MediaHorizontalCard':
      return /*#__PURE__*/_react.default.createElement(MediaHorizontalCard, {
        rendering: props.rendering,
        params: props.params
      });
    case 'StyledHeading':
      return /*#__PURE__*/_react.default.createElement(StyledHeading, {
        rendering: propRendering,
        params: props.params
      });
    case 'TabNavHorizontal':
      if (props.parentComponent !== 'tab') return /*#__PURE__*/_react.default.createElement(TabNavHorizontal, {
        rendering: propRendering,
        params: props.params
      });else return null;
    case 'TabNavVertical':
      if (props.parentComponent !== 'tab') return /*#__PURE__*/_react.default.createElement(TabNavVertical, {
        rendering: propRendering,
        params: props.params
      });else return null;
    case 'TitleTaglineDisplay':
      return /*#__PURE__*/_react.default.createElement(TitleTaglineDisplay, {
        rendering: propRendering,
        params: props.params
      });
    case 'VerticalCard':
      return /*#__PURE__*/_react.default.createElement(VerticalCard, {
        rendering: propRendering,
        params: props.params
      });
    case 'VerticalTimeline':
      return /*#__PURE__*/_react.default.createElement(VerticalTimeline, {
        rendering: propRendering,
        params: props.params
      });
    case 'VideoPlayer':
      return /*#__PURE__*/_react.default.createElement(VideoPlayer, {
        rendering: propRendering,
        params: props.params
      });
    default:
      return null;
  }
};
var _default = exports.default = LoadComponent;